import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from "../../../Redux/Slice/AxiosInstance/AxiosInstance";
import Cookies from "js-cookie";
import axios from 'axios';

const BaseURL = process.env.REACT_APP_API_URL;

const FinancialYear = Cookies.get("FinancialYear");
const Firm = Cookies.get("Firm");
const DataBase = Cookies.get("Database");

const FinancialYear1 = Cookies.get("FillterFinancialYear");
const Firm1 = Cookies.get("FillterFirm");


export const Colour = createAsyncThunk(
  'Colour/find',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`/Colour/find`)
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : 'Network Error');
    }
  }
);


export const Loginuser = createAsyncThunk('ClientLogin', async (data) => {
  try {

    const response = await api.post(`/ClientLogin`, data);
    return response.data;
  } catch (error) {
    throw new Error(error.response ? error.response.data : 'Network Error');
  }
});

export const verify = createAsyncThunk('Clientverify', async (data) => {
  try {
    const response = await api.post(`/Clientverify`, data);
    return response.data;
  } catch (error) {
    throw new Error(error.response ? error.response.data : 'Network Error');
  }
});

export const FirmAndUser = createAsyncThunk('MillStageWeb/FirmAndUser', async (data) => {
  try {
    const response = await axios.post(`${BaseURL}/MillStageWeb/FirmAndUser`, {
      DataBase: data.MSDBName
    }, {
      headers: {
        token: data.token,
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      }
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response ? error.response.data : 'Network Error');
  }
});

export const Filter = createAsyncThunk('/Filter/FillterData', async (data) => {
  try {
    const response = await axios.get(`${BaseURL}/Filter/FillterData`, {
      headers: {
        token: data,
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response ? error.response.data : 'Network Error');
  }
});

export const FilterProject = createAsyncThunk('/Filter/FillterProject', async (data) => {
  try {
    const response = await api.get(`/Filter/FillterProject`,);
    return response.data;
  } catch (error) {
    throw new Error(error.response ? error.response.data : 'Network Error');
  }
});

export const FilterMain = createAsyncThunk('/Filter/Fillter', async (data) => {
  try {
    const response = await api.post(`/Filter/Fillter`, {
      FirmIDs: Firm,
      AcYearIDs: FinancialYear,
      ProductionGroupMstIDs: data.selectedIds ? data.selectedIds : "",

    },);
    return response.data;
  } catch (error) {

    throw new Error(error.response ? error.response.data : 'Network Error');
  }
});

export const MainFilter = createAsyncThunk('/Filter/MainFilter', async (data) => {
  try {
    const response = await api.post(`/Filter/MainFilter`, {},);
    return response.data;
  } catch (error) {

    throw new Error(error.response ? error.response.data : 'Network Error');
  }
});

export const FillterFas = createAsyncThunk('/Filter/FillterFas', async (data) => {
  try {
    const response = await api.post(`/Filter/FillterFas`, {
      FirmIDs: Firm,
      AcYearIDs: FinancialYear,

    },);
    return response.data;
  } catch (error) {

    throw new Error(error.response ? error.response.data : 'Network Error');
  }
});



export const JobExecData = createAsyncThunk('/Filter/JobExecData', async (data) => {
  try {
    const response = await api.post(`/Filter/JobExecData`, {},);
    return response.data;
  } catch (error) {
    throw new Error(error.response ? error.response.data : 'Network Error');
  }
});


const loginSlice = createSlice({
  name: 'ClientLogin',
  initialState: {
    data: null,
    verifyData: null,
    filterData: null,
    mainFilterData: null,
    Colourdata: null,
    DataMain: null,
    FilterProjectdata: null,
    JobExecDatas: null,
    FillterFasdata: null,

    loginLoading: false,
    verifyLoading: false,
    filterLoading: false,
    mainFilterLoading: false,
    JobLoading: false,

    loginError: null,
    verifyError: null,
    filterError: null,
    mainFilterError: null,

  },
  reducers: {
  },

  extraReducers: (builder) => {
    // Login
    builder
      .addCase(Loginuser.pending, (state) => {
        state.loginLoading = true;
        state.loginError = null;
      })
      .addCase(Loginuser.fulfilled, (state, action) => {
        state.loginLoading = false;
        state.data = action.payload;
      })
      .addCase(Loginuser.rejected, (state, action) => {
        state.loginLoading = false;
        state.loginError = action.payload || action.error.message;
      });

    builder
      .addCase(FirmAndUser.pending, (state) => {
        state.filterLoading = true;
        state.filterError = null;
      })
      .addCase(FirmAndUser.fulfilled, (state, action) => {
        state.filterLoading = false;
        
        const mappedFirms = action.payload.Firm?.map(f => ({
          ...f,
          GroupName: f.FirmName,
          DashboardFirmID: f.FirmID
        })) || [];

        state.filterData = {
          ...state.filterData,
          Firm_List: mappedFirms,
          User_List: action.payload.User,
          ProcessGrp: action.payload.Master
        };

        if (state.DataMain) {
          state.DataMain = {
            ...state.DataMain,
            Firm_List: mappedFirms
          };
        } else {
          state.DataMain = {
            Firm_List: mappedFirms
          };
        }
      })
      .addCase(FirmAndUser.rejected, (state, action) => {
        state.filterLoading = false;
        state.filterError = action.payload || action.error.message;
      });

    // Verify
    builder
      .addCase(verify.pending, (state) => {
        state.verifyLoading = true;
        state.verifyError = null;
      })
      .addCase(verify.fulfilled, (state, action) => {
        state.verifyLoading = false;
        state.verifyData = action.payload; // Renamed from 'Main' for clarity
      })
      .addCase(verify.rejected, (state, action) => {
        state.verifyLoading = false;
        state.verifyError = action.payload || action.error.message;
      });

    // Filter
    builder
      .addCase(Filter.pending, (state) => {
        state.filterLoading = true;
        state.filterError = null;
      })
      .addCase(Filter.fulfilled, (state, action) => {
        state.filterLoading = false;
        state.filterData = action.payload; // Renamed from 'fillter' for clarity
      })
      .addCase(Filter.rejected, (state, action) => {
        state.filterLoading = false;
        state.filterError = action.payload || action.error.message;
      });

    // FilterMain
    builder
      .addCase(FilterMain.pending, (state) => {
        state.mainFilterLoading = true;
        state.mainFilterError = null;
      })
      .addCase(FilterMain.fulfilled, (state, action) => {
        state.mainFilterLoading = false;
        state.mainFilterData = action.payload; // Renamed from 'MainFilter' for clarity
      })
      .addCase(FilterMain.rejected, (state, action) => {
        state.mainFilterLoading = false;
        state.mainFilterError = action.payload || action.error.message;
      });

    builder
      .addCase(Colour.pending, (state) => {
        state.mainFilterLoading = true;
        state.mainFilterError = null;
      })
      .addCase(Colour.fulfilled, (state, action) => {
        state.mainFilterLoading = false;
        state.Colourdata = action.payload; // Renamed from 'MainFilter' for clarity
      })
      .addCase(Colour.rejected, (state, action) => {
        state.mainFilterLoading = false;
        state.mainFilterError = action.payload || action.error.message;
      });


    builder
      .addCase(MainFilter.pending, (state) => {
        state.mainFilterLoading = true;
        state.mainFilterError = null;
      })
      .addCase(MainFilter.fulfilled, (state, action) => {
        state.mainFilterLoading = false;
        state.DataMain = action.payload; // Renamed from 'MainFilter' for clarity
      })
      .addCase(MainFilter.rejected, (state, action) => {
        state.mainFilterLoading = false;
        state.mainFilterError = action.payload || action.error.message;
      });


    builder
      .addCase(JobExecData.pending, (state) => {
        state.JobLoading = true;
        state.mainFilterError = null;
      })
      .addCase(JobExecData.fulfilled, (state, action) => {
        state.JobLoading = false;
        state.JobExecDatas = action.payload; // Renamed from 'MainFilter' for clarity
      })
      .addCase(JobExecData.rejected, (state, action) => {
        state.JobLoading = false;
        state.mainFilterError = action.payload || action.error.message;
      });


    builder
      .addCase(FilterProject.pending, (state) => {
        state.mainFilterLoading = true;
        state.mainFilterError = null;
      })
      .addCase(FilterProject.fulfilled, (state, action) => {
        state.mainFilterLoading = false;
        state.FilterProjectdata = action.payload; // Renamed from 'MainFilter' for clarity
      })
      .addCase(FilterProject.rejected, (state, action) => {
        state.mainFilterLoading = false;
        state.mainFilterError = action.payload || action.error.message;
      });

    builder
      .addCase(FillterFas.pending, (state) => {
        state.mainFilterLoading = true;
        state.mainFilterError = null;
      })
      .addCase(FillterFas.fulfilled, (state, action) => {
        state.mainFilterLoading = false;
        state.FillterFasdata = action.payload; // Renamed from 'MainFilter' for clarity
      })
      .addCase(FillterFas.rejected, (state, action) => {
        state.mainFilterLoading = false;
        state.mainFilterError = action.payload || action.error.message;
      });



  },
});

export default loginSlice.reducer;